import { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { routes } from './Routes';
import { firebase_app } from '../Config/Config';
import { resolveMaxParkAdminAccess } from '../auth/maxParkAdminAccess';
import AppLayoutAdmin from '../Pages/Dashboard/LayoutAdmin';
import Loader from '../CommonElements/Loader';

const AccessDenied = () => (
  <div className="page-wrapper compact-wrapper">
    <div className="error-wrapper">
      <div className="container">
        <h3>Acces refuse</h3>
        <p>Ce compte n'a pas le role administrateur MaxPark requis.</p>
      </div>
    </div>
  </div>
);

const LayoutRoutes = () => {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [adminAccess, setAdminAccess] = useState({
    status: 'loading',
    allowed: false,
    source: ''
  });

  useEffect(() => {
    let active = true;

    const unsubscribe = firebase_app.auth().onAuthStateChanged(async (user) => {
      if (!active) {
        return;
      }

      setCurrentUser(user || null);

      if (!user) {
        setAdminAccess({
          status: 'ready',
          allowed: false,
          source: 'signed-out'
        });
        return;
      }

      setAdminAccess({
        status: 'loading',
        allowed: false,
        source: ''
      });

      try {
        const access = await resolveMaxParkAdminAccess(user);

        if (active) {
          setAdminAccess({
            status: 'ready',
            ...access
          });
        }
      } catch (error) {
        console.error('Unable to verify MaxPark admin access', error);

        if (active) {
          setAdminAccess({
            status: 'ready',
            allowed: false,
            source: 'error'
          });
        }
      }
    });

    return () => {
      active = false;
      unsubscribe();
    };
  }, []);

  return (
    <Routes>
      {routes.map(({ path, Component, type }, i) => {
        if (type === 'dashboard') {
          if (currentUser === undefined || adminAccess.status === 'loading') {
            return <Route key={i} path={path} element={<Loader />} />;
          }

          if (!currentUser) {
            return <Route key={i} path={path} element={<Navigate to="/auth" replace />} />;
          }

          if (!adminAccess.allowed) {
            return <Route key={i} path={path} element={<AccessDenied />} />;
          }

          return (
            <Route element={<AppLayoutAdmin />} key={i}>
              <Route
                path={path}
                element={Component}
              />
            </Route>
          );
        }

        return <Route key={i} path={path} element={Component} />;
      })}
    </Routes>
  );
};

export default LayoutRoutes;
